const en = {
  common: {
    login: {
      email: 'Email',
      password: 'Password',
      signIn: 'Log in',
      forgotPassword: 'Forgot password',
      signUp: 'Sign up',
      errorInvalidCredentials: 'Please check your email and password.',
      errorDuringLogin: 'An error occurred during login',
      validation: {
        emailRequired: 'Please enter your email.',
        passwordRequired: 'Please enter your password.',
      },
      education: {
        noneTitle: 'No courses in progress.',
        noneDesc: 'You can log in once available courses are registered.',
      },
    },
    join: {
      title: 'Sign up',
      subtitle: 'Please enter the required information to sign up.',
      complete: 'Sign up complete!',
      welcome: 'Welcome, {{name}}.',
      completeDesc: 'You can now use various features of {{company}}.',
      goHome: 'Go to home',
      name: 'Name',
      email: 'Email (User ID)',
      emailPlaceholder: 'Please enter your email.',
      phone: 'Phone number',
      phonePlaceholder: 'Please enter your phone number.',
      phoneGlobalPlaceholder: 'Enter your phone number.',
      searchCountry: 'Search for a country.',
      password: 'Password',
      passwordConfirm: 'Confirm password',
      passwordPlaceholder: 'Please enter your password.',
      passwordConfirmPlaceholder: 'Please enter your password again.',
      checkDup: 'Check',
      verify: 'Verify',
      resendEmail: 'Resend verification email',
      emailSent: 'Verification email sent.',
      emailResent: 'Verification email resent.',
      emailVerification: 'Email verification',
      emailCodePlaceholder: 'Enter verification code.',
      emailResendCooldown: 'Resending is available after 1 minute.',
      emailCodeExpired: 'Time expired. Please check your email and verify.',
      emailCodeInvalid: 'Please check the verification code.',
      emailAvailable: 'This phone number is available for signup.',
      submit: 'Sign up',
      terms: 'Terms',
      acceptAllRequired: 'Accept all required terms',
      tos: '(Required) Terms of Service',
      privacy: '(Required) Privacy Policy',
      viewDetail: 'View details',
      acceptAllOptional: 'Accept all optional terms',
      marketingEmail: '(Optional) Accept marketing emails',
      marketingSms: '(Optional) Accept marketing SMS',
      validation: {
        nameRequired: 'Please enter your name.',
        nameMax: 'Please enter up to 30 characters.',
        nameChars: 'Only Korean and English letters are allowed.',
        nameCharsWithSpace: 'Only Korean and English letters are allowed. Consecutive spaces are not permitted.',
        emailRequired: 'Please enter your email.',
        emailFormat: 'Invalid email format.',
        phoneRequired: 'Please enter your phone number.',
        phoneFormat: 'Enter in the format 010-0000-0000.',
        phoneInvalid: 'Please enter a valid phone number.',
        phoneMax: 'Phone number must be 15 digits or less.',
        phoneTotalMax: 'Country code and phone number must be 20 characters or less.',
        passwordMin: 'Enter at least 10 characters.',
        passwordTypes: 'Include at least two of letters, numbers, or symbols.',
        passwordRepeat: 'No more than 3 identical consecutive digits.',
        passwordMatch: 'Passwords do not match.',
        emailDupRequired: 'Email duplication check has not been completed.',
        phoneDupRequired: 'Phone number duplication check has not been completed.',
        emailDup: 'Email already in use. Try another one.',
        phoneDup: 'Phone number already in use. Try another one.',
      },
      error: {
        emailSend: 'An error occurred while sending verification email.',
        registerFailed: 'Registration failed.',
        dialogTitle: 'Sign up failed',
      },
    },
    findPassword: {
      title: 'Find password',
      emailFormat: 'Invalid email format.',
      descriptionLine1: 'Forgot your password?',
      descriptionLine2: 'A password reset link will be sent to your email.',
      emailLabel: 'Email (User ID)',
      emailPlaceholder: 'Please enter your email.',
      sendEmail: 'Send email',
      toastSent: 'Email sent.',
      toastFailed: 'Failed to send email.',
      notRegistered: 'This email is not registered.',
      resent: 'Email resent.',
      resendCooldown: 'Resending is available after 1 minute.',
      afterSentTitle: 'We sent a reset link to the email you entered.',
      resendEmail: 'Resend email',
      checkSpam: 'If you have not received the email, please check your spam folder!',
    },
    expiredToken: {
      title: 'This page has expired.',
      descLine1: 'To reset your password,',
      descLine2: 'go back to the login page and try again.',
      backToLogin: 'Back to login',
    },
    menu: {
      my: 'My Courses',
      application: 'Applications',
      account: 'Account',
    },
    cta: {
      before: {
        message: 'Recruiting starts at {{date}}',
        button: 'Preparing',
      },
      closed: {
        message: 'Recruitment is closed.',
        button: 'Closed',
      },
      ing: {
        // message: 'Recruitment is in progress.',
        button: 'In progress',
      },
      none: {
        message: 'Recruitment is not open at the moment.',
        button: 'Upcoming',
      },
      applyForm: {
        message: 'Time left until the deadline: {{time}}',
        button: 'Application',
        dayShort: 'd',
      },
      resume: {
        message: 'Continue your application.',
        button: 'Continue',
      },
      startLearning: {
        message: 'You can start your course now.',
        button: 'Start learning',
      },
      submitted: {
        message: 'Submission completed.',
        button: 'Submitted',
      },
    },
    auth: {
      login: 'Log in',
      logout: 'Log out',
    },
    home: {
      browsePrograms: 'Explore courses',
      browseBootcamps: 'Browse bootcamps',
      browseAllCourses: 'Browse all courses',
    },
    notFound: {
      title: 'The link has expired or the page does not exist.',
      descDesktop: 'We could not find the page you requested. Please check the address again.',
      descMobileLine1: 'We could not find the page you requested.',
      descMobileLine2: 'Please check the address again.',
      goHome: 'Go home',
      notice: {
        title: 'Post not found.',
        descDesktop:
          'The requested notice has been deleted/hidden by the administrator and cannot be accessed.',
        descMobileLine1: 'The requested notice has been deleted/hidden',
        descMobileLine2: 'by the administrator and cannot be accessed.',
        goBack: 'Go to notice list',
      },
    },
    notice: {
      title: 'Notices',
      message: 'Notice will be posted later.',
    },
    empty: 'No data available yet.',
    confirm: 'Confirm',
    cancel: 'Cancel',
    created: 'Created successfully.',
    retry: 'Retry',
    loading: 'Loading...',
    noMoreData: 'All data has been loaded.',
    selected: 'selected',
    viewMore: 'View more',
    backToList: 'Back to list',
    attachments: 'Attachments',
    attachedFileAlt: 'attached file',
    inputPlaceholder: 'Please enter text.',
    selectPlaceholder: 'Please select.',
    noOptions: 'No options',
    password: {
      show: 'Show password',
      hide: 'Hide password',
    },
    pagination: {
      prev: 'Previous page',
      next: 'Next page',
    },
    searchfield: {
      placeholder: 'Enter a keyword.',
      options: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone number',
      },
    },
    checkboxLabel: 'Text',
    attachFile: 'Attach file',
    text: 'Text',
    option1: 'Option 1',
    option2: 'Option 2',
    delete: 'Delete',
    edit: 'Edit',
    conformityModal: {
      title: 'Suitability test submission guide',
      desc1: "You haven't submitted the suitability test yet.",
      desc2: 'Please submit it to proceed with the bootcamp smoothly.',
      skipToday: "Don't show today",
      submit: 'Submit test',
    },
    programSidebar: {
      nav: {
        board: 'Classroom',
        notice: 'Notices',
        qna: 'Q&A',
        quiz: 'Quiz',
        project: 'Project',
        survey: 'Survey',
      },
      header: {
        period: 'Period',
        dday: 'D-{{dday}}',
      },
      roles: {
        trainee: 'Trainee',
        tutor: 'Instructor',
        manager: 'Manager',
      },
    },
    mymenuLine: {
      user: '{{name}}',
    },

    board: {
      views: 'Views {{value}}',
      title: 'Resources',
      lectureList: 'Lecture list',
      noLectures: 'No lectures have been registered yet.',
      notClassPeriod: 'It is not within the course period!',
      classAvailableFrom: 'You can take the course from {{date}}.',
      classStatus: {
        ing: 'In progress',
        pre: 'Scheduled',
        done: 'Completed',
        ready: 'Waiting',
      },
      completion: {
        achieved: 'Completion criteria achieved',
        notAchieved: 'Completion criteria not met',
        rateLabel: 'Course completion rate',
        targetLabel: 'Completion target',
      },
    },
    pageState: {
      searchEmpty: 'No results found.',
      error500: {
        line1: 'A temporary error occurred.',
        line2: 'Please refresh the page and try again.',
      },
    },
    banner: {
      applicationPeriod: 'Application',
      trainingPeriod: 'Training',
    },
    qnaEmpty: 'No questions yet.',
    dialog: {
      notice: 'Notice',
      cancelWriting: 'Cancel writing',
      leave: 'Leave',
      leaveConfirm: 'You have unsaved changes. Do you really want to leave?',
    },
    qna: {
      title: 'Q&A',
      searchPlaceholder: 'Search your questions',
      showMine: 'Show my Q&A',
      create: 'Create question',
      submit: 'Submit question',
      titleLabel: 'Title',
      titlePlaceholder: 'Write the key point in the title (max 25 chars)',
      contentsPlaceholder:
        '- The more specific the problem, the better.\n- Share a full screenshot if possible.\n- Please search for similar questions first.\n- You cannot edit/delete after answers are posted.\n- Abusive language may be removed by admin.',
      maxFiles: 'You can upload up to 3 files.',
      fileHint: 'Under 20MB, png/jpeg/jpg (max 3)',
      privateMessage: 'This is a private post. You do not have permission.',
      validation: {
        titleRequired: 'Title is required.',
        titleMax: 'Title must be no more than 25 characters.',
        questionRequired: 'Question is required.',
        fileHint: 'You can upload up to 3 files, a total of no more than 20MB.',
        programCodeRequired: 'Course code is required.',
      },
    },
    quiz: {
      title: 'Quiz',
      notice: {
        title: 'Notice',
        message: 'It’s not the quiz period right now!',
        availableFrom: 'You can take the quiz starting from {{date}}.',
        confirm: 'OK',
      },
    },
    survey: {
      title: 'Survey',
      notStarted: 'It is not within the survey period.',
      availableFrom: 'You can answer from {{date}}.',
      scale: {
        veryNegative: 'Strongly disagree',
        veryPositive: 'Strongly agree',
      },
    },
    resource: {
      noPermission: 'You do not have permission to take this course.',
      nextStepTitle: 'Next step',
      chapter: 'Chapter',
      viewNext: 'Next step',
      lastStepTitle: 'Last step',
      lastStepMessage: 'This is the last step.',
      goToClassroom: 'Go to classroom',
      reviewAgain: 'Review again',
    },
    player: {
      tab: {
        curriculum: 'Curriculum',
        qna: 'Q&A',
        mentor: 'AI Mentor',
        note: 'AI Note',
      },
      nav: {
        exit: 'Exit',
      },
      move: {
        prev: 'Prev',
        next: 'Next',
        step: 'step',
      },
      info: {
        title: 'Course info',
        labelTitle: 'Course title',
        labelTeacher: 'Instructor',
        labelPeriod: 'Course period',
        lifetime: 'Lifetime access',
      },
      session: {
        noMaterials: 'There are no course materials for this step.',
      },
      curriculum: {
        midterm: 'Midterm',
        hours: 'h',
        minutes: 'm',
        seconds: 's',
      },
      progress: {
        overall: 'Overall progress',
        achieved: 'achieved',
      },
      noteTooltip: {
        onlyVideo: 'Available only on video steps.',
      },
    },
    qnaDetail: {
      answered: 'Answered',
      waiting: 'Waiting',
      deleteTitle: 'Notice',
      deleteConfirm: 'Do you really want to delete this post?',
      deleteBtn: 'Delete',
      deleted: 'Deleted successfully.',
      deleteFailed: 'Failed to delete the post.',
      admin: 'Admin',
      imageAlt: 'QnA image',
    },
    qnaList: {
      viewAnswer: 'View answer',
      readMore: 'Read more',
      title: 'Questions',
      editTip: 'You can edit before the instructor answers; editing is disabled after answered.',
      emptyTitle: 'No Q&A yet.',
      emptyDesc: 'Please leave a question.',
    },
    playerQna: {
      helper: 'Please leave a question about the course you are currently studying.',
    },
    qnaEditor: {
      minContent: 'Please enter at least 10 characters.',
    },
    qnaAttach: {
      title: 'Attachments',
      attach: 'Attach file',
      hint100: 'Under 100MB and png, jpeg, jpg files (max 3)',
      maxFilesError: 'You can attach up to 3 files only.',
      dialogTitle: 'Notice',
      dialogMsg: 'You can attach up to 100MB.',
      fileName: 'File name',
      fileSize: 'Size',
    },
    answerSection: {
      title: 'Answer',
      preparing: 'We are preparing an answer.',
      backToList: 'Back to list',
    },
    surveyForm: {
      expired: 'The submission period has ended.',
      anonymous: 'The survey is anonymous.',
      question: 'Question',
      required: 'Answer is required.',
      submit: 'Submit',
      submitTitle: 'Submit',
      submitMsg1: 'You cannot edit after submission.',
      submitMsg2: 'Submission will be completed when you click confirm.',
      leavingTitle: 'Notice',
      leavingBtn: 'Leave',
      leavingMsg: 'If you leave the page, your current inputs will be discarded.',
      closedTitle: 'Survey closed',
      closedMsg: 'The survey has closed and was not submitted.',
      list: 'Back to list',
      answerPlaceholder: 'Please enter your answer. (Up to 500 characters including spaces)',
    },
    quizStatus: {
      scheduled: 'Scheduled',
      notTaken: 'Not taken',
      notSubmitted: 'Not submitted',
      submitted: 'Submitted',
      inProgress: 'In progress',
    },
    quizLabels: {
      period: 'Period',
      score: 'Score',
      grading: 'Currently grading. Please wait a moment.',
      of: '/',
      pts: 'pts',
      finalScore: 'Final score',
      total100: 'Total 100 pts',
      ended: 'The test period has ended.',
    },
    quizItem: {
      typeMulti: 'Multiple choice',
      typeSubjective: 'Short answer',
      pointSuffix: 'pts',
      answerPlaceholder: 'Please enter your answer.',
    },
    ide: {
      dialog: {
        submitCodingQuizTitle: 'Submit coding assessment',
        submitCodingQuizLine1: 'Grading is allowed only once after submission.',
        submitCodingQuizLine2: 'Do you want to submit?',
      },
      actions: {
        run: 'Run',
        submit: 'Submit',
        checkSolution: 'Check solution',
        submitThenGrade: 'Submit for grading',
        reset: 'Reset',
        cancel: 'Cancel',
      },
      resetDialog: {
        title: 'Do you really want to reset?',
        line1: 'Your written code in this step will be deleted.',
        line2: 'It will revert to the initial provided files state.',
        resetNow: 'Reset now',
        toastSuccess: 'Your input has been reset.',
      },
      mobileTab: {
        practice: 'Practice',
        codingQuiz: 'Instructions',
        editor: 'Editor',
      },
      terminal: {
        aiGrading: 'AI is grading hard! Please wait a moment.',
        errorPrefix: 'Error occurred:',
        placeholder: {
          practice: 'After running the code, you can proceed to the next step!',
          coding_quiz: 'You need to run the code and complete grading to proceed to the next step.',
        },
        tab: {
          execution: 'Run History',
          input: 'Input Data',
          submission: 'Scoring History',
        },
      },
      inputTerminal: {
        placeholderLine1: 'Please enter data.',
        placeholderLine2: 'Press Enter to input the next line.',
      },
      filetree: {
        title: 'File tree',
        root: 'Projects',
      },
      description: {
        practiceLabel: 'Practice info',
        quizLabel: 'Assessment info',
        difficulty: 'Difficulty',
        beginner: 'Beginner',
        recommendedTime: 'Recommended time',
        timeFormat: 'mm[min] ss[sec]',
      },
      codeReview: {
        header: 'AI Code Review',
        errorPrefix: 'Error:',
        reviewing: 'AI is reviewing your code...',
        analyzed: 'Analysis complete!',
        intro1: 'Likelion code review is an AI-based review page.',
        intro2: 'Have your written code reviewed by Likelion code review!',
        helpful: 'Was Likelion code review helpful?',
        leaveTitle: 'Leave your feedback.',
        leaveQuestion: 'What was inconvenient about AI code review?',
        leaveDesc: 'We value your feedback.',
        placeholder: 'Please leave your honest opinion about AI code review.',
        submitted: 'Your feedback has been submitted.',
      },
    },
    fileArea: {
      invalidExtension: 'This file type is not allowed. Only specified types can be uploaded.',
      sizeExceeded: 'File is too large. Up to {{mb}}MB is allowed.',
      remove: 'Remove file',
      uploadedAlt: 'uploaded file',
    },
    technology: {
      note: {
        title: 'Resources',
        subtitle: 'Please check the materials needed for the course.',
        chapter: 'Chapter {{order}}. {{title}}',
        noMaterials: 'There are no course materials.',
        links: 'Related links',
        downloads: 'Download files',
      },
      badge: {
        note: 'Resources',
        survey: 'Survey',
        quiz: 'Assessment',
        codingQuiz: 'Coding quiz',
        practice: 'Practice',
      },
      quiz: {
        header: 'Assessment',
        headerTraining: 'Training assessment',
        submitSuccess: 'Assessment has been submitted.',
        submitSuccessTraining: 'Training assessment has been submitted.',
        explanationTitle: 'Explanation',
        answer: {
          correct: 'Correct',
          incorrect: 'Incorrect',
        },
        enlargedAlt: 'Enlarged Image',
        fileUpload: {
          label: 'File upload',
          placeholder: 'Attach file (max 300MB: pdf / ppt / zip)',
          sizeExceeded: 'You can upload up to 300MB.',
          uploadFail: 'Upload failed.',
          downloadFail: 'File download failed.',
        },
      },
      survey: {
        header: 'Survey',
        weeksTitle: '{{weeks}}th survey',
        submitSuccess: 'Survey has been submitted.',
        answerPlaceholder: 'Please enter your answer. (Max 300 chars incl. spaces)',
        questionBadge: 'Question {{num}}',
      },
    },
    projectSubmit: {
      attachments: 'Attachments',
      title: 'Submit',
      desc: 'You cannot edit after final submission.',
      linkLabel: 'Attached link',
      linkPlaceholder: 'Please enter the link with https://',
      linkTitle: 'Link attachment',
      fileLabel: 'Attached file name',
      fileTitle: 'File attachment',
      filePlaceholder: 'Please attach a file (max 300MB: pdf / ppt / zip)',
      confirmLine1: 'I have checked each item and',
      confirmLine2: 'I will submit the project.',
      submit: 'Submit',
    },
    project: {
      title: 'Project',
      notPeriodTitle: 'Notice',
      notPeriodLine1: 'It is not within the submission period.',
      notPeriodLine2: 'You can submit at {{date}}.',
      confirm: 'Confirm',
      guideTitle: 'Submission guide',
      status: {
        scheduled: 'Scheduled',
        submitted: 'Submitted',
        notSubmitted: 'Not submitted',
        inProgress: 'In progress',
      },
      period: 'Submission period',
      deadlineToday: 'Due today at {{time}}',
      deadlineDays: '{{days}} days left until deadline',
      cancel: 'Cancel',
      submit: 'Submit',
      backToList: 'Back to list',
      leaveTitle: 'Notice',
      leaveLine1: 'Leave without submitting?',
      leaveLine2: 'Your current inputs will be discarded.',
      leave: 'Leave',
      keep: 'Continue',
    },
    reset: {
      title1: 'For your privacy',
      title2: 'Please reset your password.',
      password: 'New password',
      confirmPassword: 'Confirm new password',
      submit: 'Change',
      toastSuccess: 'Password has been reset successfully.',
      toastError: 'Failed to reset password.',
      apiError: 'Failed to change the password.',
      validation: {
        passwordRequired: 'Please enter a new password',
        passwordMin: 'Enter at least 10 characters',
        passwordComplexity: 'Include at least two of letters, numbers, or symbols',
        passwordRepeat: 'No more than 3 identical consecutive characters',
        confirmRequired: 'Please confirm the password',
        match: 'Passwords do not match',
      },
    },
    mymenu: {
      inProgressApplications: 'Applications in progress',
      browseCourses: 'Browse courses',
      noApplications: 'No applications in progress.',
      goBrowse: 'Go explore courses',
      noPrograms: 'No courses registered yet.',
    },
    my: {
      filter: {
        all: 'All',
        progress: 'In progress',
        scheduled: 'Scheduled',
        completed: 'Completed',
      },
    },
    application: {
      pending: {
        line1: 'You have an application in progress.',
        line2: 'Please complete your application!',
        cta: 'Continue',
      },
      submitted: 'Your application is under review.',
      passed: {
        line1: 'You have been selected as a successful candidate!',
        line2: 'After confirmation, you can check it in My Courses.',
      },
      spared: {
        line1: '{{name}}, you have been selected as a reserve candidate.',
        line2: 'If a vacancy occurs, additional registration will proceed sequentially.',
        line3: 'Notice within one week after the start; we will contact you individually.',
      },
      failed: {
        line1: 'We are sorry, {{name}}. Your application was not accepted.',
        line2: 'Please try again next time.',
      },
      canceledReason: 'Cancellation reason',
      filters: {
        all: 'All',
        inProgress: 'In progress',
        result: 'Results',
        canceled: 'Canceled',
      },
      labels: {
        recruitPeriod: 'Application',
        announceDate: 'Results',
        announceDesc: 'Individual notice within 7 days from application date',
      },
      statusLabel: {
        apply: 'Application',
        review: 'Review',
        pass: 'Pass',
        spared: 'Reserved pass',
        fail: 'Declined',
        cancel: 'Canceled',
        form: 'Fill application',
        formReview: 'Application review',
      },
      status: {
        pendingLabel: 'Applying',
        submittedLabel: 'Under review',
        passedLabel: 'Passed',
        sparedLabel: 'Reserved pass',
        failedLabel: 'Declined',
        canceledLabel: 'Canceled',
      },
      cancel: {
        selectReason: 'Select a cancellation reason',
        inputReason: 'Please enter a cancellation reason',
        button: 'Withdraw',
        short: 'Withdraw',
        reason: {
          personal: 'Personal reasons for difficulty in taking the course',
          schedule: 'The schedule does not match, cancel the application',
          duplicate: 'Already applied to a similar other course',
          mistake: 'Incorrect information entered in the application',
          interest: 'Interest in the current course has decreased',
          etc: 'etc',
        },
        notice: 'After the application is canceled, it cannot be restored.',
        toast: 'Application canceled.',
      },
    },
    programItem: {
      period: 'Period',
      lectureCount: 'Lectures',
      progressRate: 'Progress',
      completionNoteAll100: 'Certificate is issued when 100% progress in all lectures',
      completionNoteAvg: 'Certificate issued when average progress reaches {{rate}}%',
      lectureSuffix: 'lecture {{count}}',
      lectureCountValue: '{{count}} lectures',
      completionBadge: {
        achieved: 'Completion achieved',
        notAchieved: 'Not completed',
      },
    },
    sidebar: {
      menu: 'Menu',
    },
    companyInfo: {
      links: {
        tos: 'Terms of Service',
        privacy: 'Privacy Policy',
      },
      labels: {
        name: 'Company name',
        ceo: 'Representative',
        phone: 'Phone',
        businessNumber: 'Business registration number',
        mailOrderNumber: 'Mail-order business number',
        address: 'Address',
      },
    },
    account: {
      title: 'Account',
      section: {
        member: 'Member information',
        security: 'Security settings',
        marketing: 'Marketing consent',
        settings: 'Settings',
      },
      labels: {
        name: 'Name',
        email: 'Email',
        password: 'Password',
        passwordConfirm: 'Confirm password',
        marketingEmail: '(Optional) Email consent',
        marketingSms: '(Optional) SMS consent',
        language: 'Language',
      },
      placeholders: {
        password: 'At least 10 chars: letters, numbers, symbols',
        passwordConfirm: 'Re-enter new password',
      },
      modal: {
        title: 'Change password',
      },
      actions: {
        changePassword: 'Change password',
        submitChange: 'Change',
      },
      toast: {
        saveFailed: 'Failed to save. Please try again.',
        changePasswordSuccess: 'Password changed successfully.',
      },
    },
    apply: {
      header: {
        title: 'Application form',
        stepSuffix: 'step(s)',
      },
      footer: {
        saveTemp: 'Save draft',
        next: 'Next',
        agreeAndContinue: 'Agree and continue',
        submitFinal: 'Submit final',
      },
      exitModal: {
        title: 'Cancel writing notice',
        line1: 'There are unsaved changes.',
        line2: 'Do you want to save and leave?',
        continue: 'Continue',
        saveAndExit: 'Save & exit',
      },
      lastConfirm: {
        title: 'Submit final',
        line1: 'You cannot edit after final submission.',
        line2: 'Do you want to submit?',
        button: 'Submit final',
        submitting: 'Uploading...',
        submittingDescription: 'Uploading files.\nPlease wait a moment.',
      },
      toast: {
        saved: 'Saved successfully.',
      },
      error: {
        generic: 'An error occurred. Please try again.',
        fileUpload: 'File upload failed. Please check the file and try again.',
      },
      badge: {
        required: 'Required',
        multiSelect: 'Multiple selection allowed',
      },
      prev: 'Back',
      phase01: {
        title: 'Please check the applicant information.',
      },
      labels: {
        name: 'Name',
        emailAddress: 'Email',
        phone: 'Contact',
      },
      terms: {
        allAgree: 'Agree to all required terms',
        requiredPolicy1: '[Required] Consent to collection and use of personal information',
        requiredPolicy2: '[Required] Consent to provision of personal information to third parties',
      },
      placeholders: {
        input: 'Please enter text.',
      },
      lengthGuide: {
        both: '/Min {{min}}, Max {{max}} chars',
        min: '/Min {{min}} chars',
        max: '/Max {{max}} chars',
      },
      charSuffix: ' chars',
      validation: {
        required: 'This field is required.',
        minLength: 'Enter at least {{min}} characters',
        maxLength: 'Enter no more than {{max}} characters',
        atLeastOne: 'Please select at least one.',
        invalid: 'Invalid value.',
      },
      file: {
        attachPrompt: 'Please attach a file.',
        types: '(pdf, zip, jpg, png)',
      },
      complete: {
        title: 'Submission completed.',
        labels: {
          programName: 'Course name',
          submittedAt: 'Submitted',
        },
        button: {
          viewApplications: 'View applications',
        },
      },
    },
  },
}
export default en
